/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerateStreamContainer_story = {
    readonly id: string;
    readonly canModerate: boolean;
    readonly " $refType": "ModerateStreamContainer_story";
};
export type ModerateStreamContainer_story$data = ModerateStreamContainer_story;
export type ModerateStreamContainer_story$key = {
    readonly " $data"?: ModerateStreamContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerateStreamContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerateStreamContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canModerate",
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '5f5eab55fed6b6e0f41ff0a2c2a05c12';
export default node;
